import React from 'react';

import { JackpotWinnersModel } from '../../../../../../../models';
import { JackpotTierName } from '../../../../../../../enums';
import { useTranslation } from '../../../../../../../hooks';
import { JackpotTierWinner } from '../jackpt-tier-winner';
import { T } from '../../../../../../../constants';

interface JackpotTierWinnersProps {
  symbol: string;
  tierName: JackpotTierName;
  data?: JackpotWinnersModel;
}

export const JackpotTierWinners: React.FC<JackpotTierWinnersProps> = ({
  data,
  symbol,
  tierName,
}) => {

  const t = useTranslation();

  return (
    <div className="jackpot-popup-content-bl">
      <div className="jackpot-popup-content-bl-info">
        <JackpotTierWinner
          symbol={symbol}
          tierName={tierName}
          title={t(T.TOP_WINNER)}
          date={data?.maxWinDate}
          winAmount={data?.maxWin}
          secretId={data?.maxWinUserId}
          gameName={data?.maxWinGameName}
        />
        <span className="horizontal-separator"></span>
        <JackpotTierWinner
          tierName={tierName}
          title={t(T.LAST_WINNER)}
          date={data?.lastWinDate}
          winAmount={data?.lastWin}
          secretId={data?.lastWinUserId}
          gameName={data?.lastWinGameName}
        />
      </div>
    </div>
  );
};
